import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Header } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { isGlobeInvestor } from 'utils/helpers';
import { colors } from 'utils/colors';
import { Analytics, Storage } from 'actions';
import Overview from './Overview';
import Performance from './Performance';
import PortfolioHistory from './PortfolioHistory';
import Downside, { formatVaRAbs, hasVaRData, hasVaRValue } from './Downside';
import Fees from './Fees';
import Income from './Income';
import Diversification from './Diversification';
import AssetClass from './Diversification/AssetClass';
import IndividualAsset from './Diversification/IndividualAsset';
import Region from './Diversification/Region';
import GlobalSector from './Diversification/GlobalSector';
import MacroFactor from './Diversification/MacroFactor';
import EquityStyle from './Diversification/EquityStyle';
import ESG from './ESG';
import CaFootNote from './FootNote/CaFootNote';
import FrFootNote from './FootNote/FrFootNote';
import NonCaFootNote from './FootNote/NonCaFootNote';
import { translation } from '../../Translation/scorecard';
import { isStandalone } from '../../../utils/helpers';

@withRouter
@connect((state) => ({
  analytics: state.Analytics,
  user_region: state.Storage.user_region || 'CA',
  esg: state.Analytics.esg,
  partnerName: state.Storage['partner-name'],
  globe_destination: state.Storage.globe_destination,
  french: state.Storage.language === 'fr',
}))
export default class Result extends Component {
  timeoutId = null;

  constructor(props) {
    super(props);
    const mql = window.matchMedia('print');

    this.state = {
      isPrintReady: false,
      mql,
    };
  }

  componentWillMount() {
    // const { match } = this.props;
    // const { id } = match.params;

    // resize charts on print
    const { mql } = this.state;
    mql.addListener(this.printListener);

    // if (Number(id) && !drawdown.name) {
    //  return dispatch(Planning.fetchDrawdownPlanId(id));
    // }

    return false;
  }

  componentDidMount() {
    this.timeoutId = window.setTimeout(
      () => this.setState({ isPrintReady: true }),
      1000
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPrintReady } = this.state;
    if (isPrintReady !== prevState.isPrintReady) {
      const originalTitle = document.title;
      document.title = `${originalTitle}.PDF`;
      window.print();
      document.title = originalTitle;
    }
  }

  componentWillUnmount() {
    const { history, dispatch } = this.props;
    const { mql } = this.state;
    const overviewRegex = /^\/portfolio\/.*\/overview$/;
    const pdfRegex = /^\/portfolio\/.*\/pdf$/;
    const standaloneRegex = /^\/portfolio\/overview$/;

    window.clearTimeout(this.timeoutId);
    mql.removeListener(this.printListener);

    if (
      !overviewRegex.test(history.location.pathname) &&
      !pdfRegex.test(history.location.pathname) &&
      !standaloneRegex
    ) {
      dispatch(Analytics.clearAnalytics());
      dispatch(Storage.removeItem('pwpa-has-exclude-holding'));
      dispatch(Storage.removeItem('pwpa-check-history'));
    }

    // Reset printLetterGrade everytime after print to prevent scores are removed from scorecard on the app
    dispatch(
      Analytics.updatePrintParams({
        printLetterGrade: true,
      })
    );
  }

  printListener = (e) => {
    const { history, match, partnerName, globe_destination } = this.props;
    // resize charts on print
    if (e.matches) {
      Object.keys(window.Chart.instances).forEach((key) => {
        window.Chart.instances[key].resize();
      });
    } else if (isGlobeInvestor(partnerName)) {
      if (globe_destination === 'SmartRiskPortfolioBuilder') {
        history.push(`/portfolio/find`);
      }
      if (globe_destination === 'ETFPortfolioBuilder') {
        history.push(
          `/portfolio/build-etf/${match.params.id}/analytics/overview`
        );
      }
    } else if (isStandalone(partnerName)) {
      history.push(`/scorecard/overview`);
    } else {
      history.push(`/portfolio/${match.params.id}/overview`);
    }
  };

  generateSectors = (esg) => {
    const { french } = this.props;
    const language = french ? 'fr' : 'en';
    const hasEsg = Boolean(Object.keys(esg).length);
    const componentsName = [
      'Overview',
      'PortfolioHistory',
      'Performance',
      'Downside',
      'Fees',
      'Income',
      'Diversification',
      'AssetClass',
      'IndividualAsset',
      'Region',
      'GlobalSector',
      'MacroFactor',
      'EquityStyle',
    ];
    const components = {
      Overview,
      PortfolioHistory,
      Performance,
      Downside,
      Fees,
      Income,
      Diversification,
      AssetClass,
      IndividualAsset,
      Region,
      GlobalSector,
      MacroFactor,
      EquityStyle,
      ...(Object.keys(esg).length && { ESG }),
    };
    const headers = {
      Overview: translation[language].OVERVIEW,
      PortfolioHistory: translation[language].PORTFOLIO_HISTORY,
      Performance: translation[language].PERFORMANCE,
      Downside: translation[language].DOWNSIDE,
      Fees: translation[language].FEES,
      Income: translation[language].INCOME,
      Diversification: translation[language].DIVERSIFICATION,
      AssetClass: translation[language].ASSET_CLASS,
      IndividualAsset: translation[language].INDIVIDUAL_ASSET,
      Region: translation[language].REGION,
      GlobalSector: translation[language].GLOBAL_SECTOR,
      MacroFactor: translation[language].MACRO_FACTOR,
      EquityStyle: translation[language].EQUITY_STYLE,
      ...(hasEsg && { ESG: 'ESG' }),
    };

    const subClass = [
      'AssetClass',
      'IndividualAsset',
      'Region',
      'GlobalSector',
      'MacroFactor',
      'EquityStyle',
    ];

    const { analytics } = this.props;

    if (Object.keys(esg).length) componentsName.push('ESG');

    return componentsName.map((comp, index) => {
      const marginTop = index === 0 ? null : { marginTop: '45px' };
      const RenderComponent = components[comp];
      const headingFont = subClass.includes(comp)
        ? null
        : { fontWeight: '900', fontSize: '1.6em' };
      const headerStyle = {
        position: 'absolute',
        top: '-12px',
        left: 15,
        background: 'white',
        padding: '0 5px',
        margin: 0,
        ...headingFont,
      };

      return (
        <div>
          <div style={marginTop}>
            <Section>
              <Header
                size="medium"
                content={headers[comp]}
                style={headerStyle}
              />
              <RenderComponent analytics={analytics} esg={esg} />
            </Section>
          </div>
          <div style={{ pageBreakAfter: 'always' }} />
        </div>
      );
    });
  };

  renderFootNote = () => {
    const { user_region, esg, french, analytics } = this.props;
    const hasEsg = Boolean(Object.keys(esg).length);
    const { printLetterGrade } = analytics;
    let footnoteNumber = 0;
    const nextFootnoteNumber = () => (footnoteNumber += 1);
    const printParams = analytics.printParams || {};
    const analyticsData = analytics.data || {};
    const showVaRFootnote = printParams.Downside && hasVaRData(analyticsData);
    const VaR =
      analyticsData.fratios &&
      analyticsData.fratios.portfolio &&
      analyticsData.fratios.portfolio.VaR;
    const varLoss = VaR && hasVaRValue(VaR.p5) ? formatVaRAbs(VaR.p5) : '5';

    if (printLetterGrade) {
      return user_region === 'CA' ? (
        french ? (
          <FrFootNote analytics={analytics} hasEsg={hasEsg} />
        ) : (
          <CaFootNote analytics={analytics} hasEsg={hasEsg} />
        )
      ) : (
        <NonCaFootNote analytics={analytics} hasEsg={hasEsg} />
      );
    }

    return (
      <div>
        <P>
          {nextFootnoteNumber()}. Wealthscope Portfolio Scorecard guidelines:
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;To protect the integrity of the
          statistical analysis, Wealthscope implements the following rules when
          analyzing your portfolio:
          <br />
          <ul style={{ listStyleType: 'disc', transform: 'translateX(12px)' }}>
            <li>
              If all of the securities in the portfolio have more than or equal
              to 48 months of history, all of the analysis will be performed.
              Otherwise, we exclude the following securities:
              <ul style={{ listStyleType: 'circle' }}>
                <li>Securities that have less than 36 months of history;</li>
                <li>
                  Securities that have between 36 and 47 months of history and
                  collectively weigh less than 10% of the portfolio.
                </li>
              </ul>
            </li>
            <li>
              For securities included in the analysis, the period of analysis
              will be the longest common history.
            </li>
            <li>
              If all of the securities in the portfolio have less than 36 months
              of history, we provide only basic summary information for the
              portfolio using the longest common history.
            </li>
            <li>
              If a passive ETF has insufficient history but there is a close
              substitute, the latter will be used in the analysis. For certain
              passive ETFs and CDRs with short history, we may use the index
              total return (minus the MER) prior to inception. See the list{' '}
              <a
                href="https://docs.google.com/spreadsheets/d/1nJP1KzqxpDQYwaIX_LX-4TTiS-0AL7so/edit?usp=sharing&ouid=113159414220847142502&rtpof=true&sd=true"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
              .
            </li>
          </ul>
        </P>
        <P>{nextFootnoteNumber()}. All key statistics are reported in CAD.</P>
        <P>
          {nextFootnoteNumber()}. The benchmark for your portfolio is
          automatically selected depending on your asset allocation. It
          represents a simple, low-cost two-ETF (one broad equity and one broad
          fixed income) alternative for your portfolio.
        </P>
        <P>
          {nextFootnoteNumber()}. The following are risk-adjusted return ratios,
          and a higher ratio is better: The Sharpe Ratio measures the
          portfolio’s reward (excess returns over the risk-free rate) per unit
          of risk. The Roy’s Safety First Criterion measures the portfolio’s
          reward (excess returns over the target rate) per unit of risk. The
          Sortino Ratio measures the portfolio’s reward (excess returns over the
          target rate) per unit of downside risk.
        </P>
        <P>
          {nextFootnoteNumber()}. The following are portfolio risk measures:
          Total risk represents the volatility of the portfolio’s returns as
          measured by its standard deviation. Downside risk is the volatility of
          the portfolio’s return below a target rate. Maximum drawdown is the
          maximum peak to trough loss during a given period. Downside capture
          measures whether the portfolio lost less than the market when there
          was a market downturn.
        </P>
        {showVaRFootnote ? (
          <P>
            {nextFootnoteNumber()}. Value-at-Risk (VaR) shows how much the
            portfolio could lose in a bad month. For example, a 5% VaR of −
            {varLoss}% means there is a 5% chance of losing more than {varLoss}%
            in a given month.
          </P>
        ) : null}
        <P>
          {nextFootnoteNumber()}. The default target rate is set to zero,
          representing nominal capital preservation.
        </P>
        <P>
          {nextFootnoteNumber()}. Fees capture product fees if you have mutual
          funds/ETFs. It can include a trailing commission for your advisor,
          depending on the share class you have (e.g., Class A).
        </P>
        <P>
          {nextFootnoteNumber()}. Diversification is scored using your
          portfolio’s average correlation and three other dimensions across i)
          geographical region, ii) business sectors, and iii) macroeconomic
          factors.
        </P>
        <P>
          {nextFootnoteNumber()}. For regional stock market, global stock
          sector, macroeconomic, and equity style diversification, we show you
          your portfolio’s risk exposures. The latter measures how much the
          volatility of your portfolio can be attributed to each factor.
          Portfolio-specific risk is the portion of your portfolio’s volatility
          that cannot be explained by the factors in question.
        </P>
        {hasEsg ? (
          <P>
            {nextFootnoteNumber()}. The Owl Analytics ESG scores are on a 0-100
            scale, with a higher score being more desirable. The Wealthscope
            grading scheme differs from the ESG scores as the grading scheme
            reflects the distribution of the scores, which is tight around the
            middle for funds (see the distribution chart).
          </P>
        ) : null}
      </div>
    );
  };

  render() {
    const { analytics, esg, french } = this.props;
    const { data, printParams } = analytics || {};
    const { portfolio } = data || {};
    const language = french ? 'fr' : 'en';

    return (
      <PDF>
        <Header
          size="large"
          content={
            printParams && printParams.printLetterGrade
              ? 'Portfolio Scorecard'
              : translation[language].PORTFOLIO_REVIEW
          }
          subheader={
            portfolio.account && Object.keys(portfolio.account).length
              ? portfolio.account.user_institution
              : portfolio.name
          }
          style={{ textAlign: 'left', margin: '0' }}
        />
        <Header
          size="medium"
          subheader={
            portfolio.account && Object.keys(portfolio.account).length
              ? portfolio.account.label
              : portfolio.description
          }
          style={{ textAlign: 'left', margin: '0 0 30px 0' }}
        />
        {this.generateSectors(esg)}
        <Header
          size="large"
          content="Footnotes"
          style={{ textAlign: 'left', marginBottom: '10px' }}
        />
        {this.renderFootNote()}
      </PDF>
    );
  }
}

Result.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  analytics: PropTypes.object,
  dispatch: PropTypes.func,
  user_region: PropTypes.string,
  esg: PropTypes.object,
  partnerName: PropTypes.string,
  globe_destination: PropTypes.string,
  french: PropTypes.bool,
};

Result.defaultProps = {
  match: {},
  history: {},
  analytics: {},
  dispatch: () => false,
  user_region: 'CA',
  esg: {},
  partnerName: '',
  globe_destination: '',
  french: false,
};

const Section = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: ${(props) => (props.single ? '45rem' : '99.5%')};
  border: 1px solid ${colors.blue};
  border-radius: 8px;
  text-align: ${(props) => (props.center ? 'center' : 'left')};
  transition: max-height 300ms ease, padding 300ms ease, border 300ms ease 300ms;
  padding: 1rem;
`;

const PDF = styled.div`
  position: relative;
  background: white;
  text-align: center;
  padding: 0.5rem;
  border-radius: 8px;
  width: 1160px;
  margin: -55px auto 5px auto;

  @media only print {
    print-color-adjust: exact;

    @page {
      size: auto;
      margin: 0.5cm;
    }
  }
`;

const P = styled.p`
  text-align: left;
  max-width: 100%;
`;
